// import { useState } from "react";

import { useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";

function ModalWrapper({ children, onClose }) {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-2xl shadow-xl p-6 max-w-md"
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
}

export default function ChatBarWithSearch({
    onSelectContact,
    onSelectGroupDetails,
    onGroupMoved,
    contacts,
    loading,
}) {
    const [search, setSearch] = useState("");
    const [imagePreview, setImagePreview] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [movingGroupId, setMovingGroupId] = useState(null);
    const [limitModal, setLimitModal] = useState({
        open: false,
        message: "",
        limitInfo: null,
    });

    const isGroupChatListLimitResponse = (data) => {
        if (String(data?.status) === "1") return false;

        const limitData = Array.isArray(data?.data) ? data.data[0] : null;
        if (limitData && (limitData.total_limit != null || limitData.used != null)) {
            return true;
        }

        const message = String(data?.message || "").toLowerCase();
        return message.includes("limit") || message.includes("upgrade");
    };

    const closeLimitModal = () => {
        setLimitModal({ open: false, message: "", limitInfo: null });
    };

    const handleMoveToChatList = async (group) => {
        const token = Cookies.get("auth_token");
        if (!token) {
            toast.error("Session expired. Please login again.");
            return;
        }

        const groupId = group?.group_id;
        if (!groupId) {
            toast.error("Unable to move this group");
            return;
        }

        try {
            setMovingGroupId(groupId);
            const body = new URLSearchParams({
                group_id: groupId,
                move_to_chat_list: "1",
            });

            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/group/move_to_chat_list`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: body.toString(),
            });

            const data = await res.json();
            if (data?.status === "1") {
                toast.success(data?.message || "Group added to chat list");
                if (typeof onGroupMoved === "function") {
                    await Promise.resolve(onGroupMoved(groupId, 1));
                }
            } else if (isGroupChatListLimitResponse(data)) {
                const limitInfo = Array.isArray(data?.data) ? data.data[0] : null;
                setLimitModal({
                    open: true,
                    message: data?.message || "Group chat list limit reached. Upgrade your plan.",
                    limitInfo,
                });
            } else {
                toast.error(data?.message || "Failed to move group to chat list");
            }
        } catch (error) {
            toast.error(error?.message || "Failed to move group to chat list");
        } finally {
            setMovingGroupId((current) => (String(current) === String(groupId) ? null : current));
        }
    };

    if (loading) {
        return (
            <div className="h-full min-h-0 overflow-hidden bg-white">
                <aside className="flex h-full min-h-0 flex-col bg-white p-4 pt-0 mt-4 lg:col-span-1 md:w-[360px] md:min-w-[300px] md:flex-shrink-0">
                    {/* Search bar skeleton */}
                    <div className="flex items-center gap-2 mb-6">
                        <div className="relative w-full">
                            <div className="h-12 w-full rounded-[20px] bg-gray-200 animate-pulse" />
                        </div>
                        <div className="h-12 w-12 rounded-full bg-gray-200 animate-pulse" />
                    </div>

                    {/* Group list skeletons */}
                    <div className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain touch-pan-y [-webkit-overflow-scrolling:touch]">
                        {Array.from({ length: 5 }).map((_, idx) => (
                            <div
                                key={idx}
                                className="flex items-center w-full gap-3 p-3 rounded-[100px] bg-gray-200 bg-opacity-60 animate-pulse"
                            >
                                <div className="h-12 w-12 rounded-full bg-gray-300" />
                                <div className="flex justify-between items-center w-full">
                                    <div className="h-4 w-32 rounded bg-gray-300" />
                                    <div className="flex gap-2">
                                        <div className="h-5 w-5 rounded-full bg-gray-300" />
                                        <div className="h-5 w-5 rounded-full bg-gray-300" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </aside>
            </div>
        );
    }

    return (
        <div className="h-full min-h-0 overflow-hidden bg-white">
            <aside className="flex h-full min-h-0 flex-col bg-white p-4 pt-0 mt-4 lg:col-span-1 md:w-[360px] md:min-w-[300px] md:flex-shrink-0">

                {/* SEARCH BAR */}
                <div className="flex items-center gap-2 mb-6 ">
                    <div className="relative w-full  ">
                    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10">
                        <img
                            src="../chatbox/magnifer.svg"
                            alt="magnifer"
                            className=" w-5 h-5"
                        />
                    </div>
                    <input
                        id="search"
                        type="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="w-full rounded-[20px] border border-gray-400 bg-white pl-12 pr-12 py-3 text-gray-800 placeholder:text-gray-400 outline-none transition focus:border-[#7C4DFF] focus:ring-4 focus:ring-[#7C4DFF]/15 shadow-md shadow-[#7C4DFF] sticky top-4 [appearance:textfield] [&::-webkit-search-cancel-button]:hidden"
                    />
                     {search && (
                    <button
                        type="button"
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                        onClick={() => setSearch("")}
                        aria-label="Clear search"
                    >
                        <img src="../chatbox/close.svg" alt="close" className="w-5 h-5" />
                    </button>
                     )}
                </div>
                    <a href="/creategroup">
                        <img src="./groupscreen/plus.svg" alt="plus" />
                    </a>
                </div>

                {/* GROUP LIST */}
                <div className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain touch-pan-y [-webkit-overflow-scrolling:touch]">

                    {showImageModal && (
                        <ModalWrapper onClose={() => setShowImageModal(false)}>
                            <div className="flex flex-col items-center gap-4">
                                <div className="h-64 w-64 rounded-full overflow-hidden border-4 border-gray-200 flex items-center justify-center bg-gray-100">
                                    <img
                                        src={imagePreview}
                                        alt="Group"
                                        className="h-full w-full object-cover"
                                    />
                                </div>
                                <button
                                    className="w-full submit-button"
                                    onClick={() => setShowImageModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </ModalWrapper>
                    )}

                    {limitModal.open && (
                        <ModalWrapper onClose={closeLimitModal}>
                            <div className="flex flex-col items-center gap-4 text-center">
                                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#F3F0FF] text-[#6C45FF]">
                                    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                        <path d="M12 9v4" strokeLinecap="round" />
                                        <path d="M12 17h.01" strokeLinecap="round" />
                                        <circle cx="12" cy="12" r="9" />
                                    </svg>
                                </div>
                                <div className="space-y-2">
                                    <h3 className="text-lg font-semibold text-[#1E1F29]">Group Limit Reached</h3>
                                    <p className="text-sm leading-relaxed text-[#7C8090]">
                                        {limitModal.message}
                                    </p>
                                    {limitModal.limitInfo ? (
                                        <p className="text-xs text-[#6C45FF]">
                                            Used {limitModal.limitInfo.used ?? 0} of {limitModal.limitInfo.total_limit ?? 0}
                                            {limitModal.limitInfo.plan_type ? ` (${limitModal.limitInfo.plan_type})` : ""}
                                        </p>
                                    ) : null}
                                </div>
                                <button
                                    type="button"
                                    className="submit-button w-full"
                                    onClick={closeLimitModal}
                                >
                                    Okay
                                </button>
                            </div>
                        </ModalWrapper>
                    )}

                    {(() => {
                        const filtered = (contacts || [])
                            .filter((g) => (g.group_name || "").toLowerCase().includes(search.toLowerCase()));

                        if (filtered.length === 0) {
                            return (
                                <div className="w-full flex items-center justify-center h-[80vh]">
                                    <div className="max-w-md w-full text-center py-12">
                                        <div className="h-24 w-24 rounded-full bg-gray-100 mx-auto flex items-center justify-center mb-6">
                                            <img src="../chatbox/Group 427319333.svg" alt="no groups" className="h-12 w-12 object-contain" />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-700 mb-2">No groups yet</h2>
                                        <p className="text-gray-400 mb-6">Create your first group to get started.</p>
                                        <a href="/creategroup" className="inline-flex items-center justify-center gap-3 submit-button">
                                            <span className="text-2xl leading-none">+</span>
                                            <span className="font-semibold">Create Group</span>
                                        </a>
                                    </div>
                                </div>
                            );
                        }

                        return filtered.map((g) => {
                            const isUnread = g.group_message_read === 1;
                            const iconSrc = isUnread ? "./groupscreen/phonebook.svg" : "../chatbox/phonebook.svg";
                            return (
                            <button
                                key={`${g.group_id}-${g.group_message_read}`}
                                className="flex items-center gap-3 p-3 py-1 rounded-[100px] border shadow-xl w-full z-40 bg-[#797C7B] border-gray-100 bg-opacity-[11%]"
                                onClick={() => onSelectContact(g.group_id)}
                            >
                                <div 
                                    className="h-12 w-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200 flex items-center justify-center cursor-pointer hover:opacity-80 transition"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setImagePreview(`${process.env.REACT_APP_API_BASE_URL}${g.group_image_url}`);
                                        setShowImageModal(true);
                                    }}
                                >
                                    <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}${g.group_image_url}`}
                                        alt={g.group_name}
                                        className="h-full w-full object-cover"
                                    />
                                </div>

                                <div className="flex justify-between items-center w-full">
                                    <p className="text-lg font-semibold whitespace-nowrap w-[60%] text-ellipsis overflow-hidden text-left">{g.group_name}</p>
                                    <div className="flex">
                                        <button
                                            type="button"
                                            className="mr-2 rounded-full text-xs font-semibold text-white  disabled:opacity-60"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleMoveToChatList(g);
                                            }}
                                            disabled={String(movingGroupId) === String(g.group_id)}
                                            title="Move to chat"
                                        >
                                            {/* {String(movingGroupId) === String(g.group_id) ? "Moving..." : "Move"} */}
                                              <img 
                                                    src= "../move.svg" 
                                                    className="w-5 h-5" 
                                                    alt="status"
                                                />
                                        </button>

                                        <img 
                                            src={iconSrc}
                                            className="w-5 h-5 mr-2" 
                                            alt="status"
                                        />

                                        <img
                                            src="./groupscreen/info.svg"
                                            className="w-5 h-5 mr-2 cursor-pointer"
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent button click
                                                if (onSelectGroupDetails) {
                                                    onSelectGroupDetails(g.group_id);
                                                } else {
                                                    onSelectContact(g.group_id);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </button>
                        )});
                    })()}
                </div>

            </aside>
        </div>
    );
}

